module.exports = {"654221100":"额敏镇","654221101":"玉什喀拉苏镇","654221102":"杰勒阿尕什镇","654221103":"上户镇","654221104":"玛热勒苏镇","654221105":"喀拉也木勒镇","654221200":"郊区乡","654221202":"额玛勒郭楞蒙古民族乡","654221207":"喇嘛昭乡","654221208":"霍吉尔特蒙古民族乡","654221209":"二道桥乡","654221400":"二支河牧场","654221401":"加尔布拉克农场","654221402":"阔什比克良种场","654221403":"萨尔也木勒牧场","654221404":"也木勒牧场","654221405":"塔城地区种羊场","654221406":"吾宗布拉克牧场","654221505":"兵团农九师一六五团","654221506":"兵团农九师一六六团","654221507":"兵团农九师一六七团","654221508":"兵团农九师一六八团","654221511":"兵团农九师团结农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654221.json
// module id = 3138
// module chunks = 0